import _styled, { default as _styled2 } from "styled-components";
var _class, _WelcomeMessage;
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component, useState, useRef } from "react";
import { Trans, useTranslation, withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import Box from "../../Styled/Box";
import Button, { RawButton } from "../../Styled/Button";
import Icon, { StyledIcon } from "../../Styled/Icon";
import Spacing from "../../Styled/Spacing";
import Text, { TextSpan } from "../../Styled/Text";
import { ExplorerWindowElementName } from "../ExplorerWindow/ExplorerWindow";
import { useKeyPress } from "../Hooks/useKeyPress.js";
import VideoGuide from "../Map/Panels/HelpPanel/VideoGuide";
import { withViewState } from "../Context";
import { TourPortalDisplayName } from "../Tour/TourPortal";
import FadeIn from "../Transitions/FadeIn/FadeIn";
import SlideUpFadeIn from "../Transitions/SlideUpFadeIn/SlideUpFadeIn";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const WELCOME_MESSAGE_NAME = "welcomeMessage";
export const LOCAL_PROPERTY_KEY = "".concat(WELCOME_MESSAGE_NAME, "Prompted");
const WELCOME_MESSAGE_VIDEO = "welcomeMessageVideo";
const WelcomeModalWrapper = styled(Box).withConfig({
  displayName: "WelcomeMessage__WelcomeModalWrapper",
  componentId: "sc-1xu3b82-0"
})(["z-index:99999;background-color:rgba(0,0,0,0.75);"]);
function WelcomeMessageButton(props) {
  return /*#__PURE__*/_jsx(Button, {
    primary: true,
    rounded: true,
    fullWidth: true,
    onClick: props.onClick,
    children: /*#__PURE__*/_jsxs(Box, {
      centered: true,
      children: [props.buttonIcon && /*#__PURE__*/_jsx(StyledIcon, {
        light: true,
        styledWidth: "22px",
        glyph: props.buttonIcon
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 2
      }), props.buttonText && /*#__PURE__*/_jsx(TextSpan, {
        textLight: true,
        extraLarge: true,
        children: props.buttonText
      })]
    })
  });
}
WelcomeMessageButton.propTypes = {
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.object,
  onClick: PropTypes.func
};
let WelcomeMessage = observer(_class = (_WelcomeMessage = class WelcomeMessage extends Component {
  constructor(props) {
    super(props);
    const viewState = this.props.viewState;
    const shouldShow = viewState.terria.configParameters.showWelcomeMessage && !viewState.terria.getLocalProperty(LOCAL_PROPERTY_KEY) || false;
    this.props.viewState.setShowWelcomeMessage(shouldShow);
  }
  render() {
    const viewState = this.props.viewState || {};
    return /*#__PURE__*/_jsx(WelcomeMessagePure, {
      showWelcomeMessage: viewState.showWelcomeMessage,
      setShowWelcomeMessage: bool => this.props.viewState.setShowWelcomeMessage(bool),
      isTopElement: this.props.viewState.topElement === "WelcomeMessage",
      viewState: this.props.viewState
    });
  }
}, _defineProperty(_WelcomeMessage, "displayName", "WelcomeMessage"), _defineProperty(_WelcomeMessage, "propTypes", {
  viewState: PropTypes.object,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired
}), _WelcomeMessage)) || _class;
export const WelcomeMessagePure = props => {
  const {
    showWelcomeMessage,
    setShowWelcomeMessage,
    viewState
  } = props;
  const {
    t
  } = useTranslation();
  // This is required so we can do nested animations
  const [welcomeVisible, setWelcomeVisible] = useState(showWelcomeMessage);
  const [shouldTakeTour, setShouldTakeTour] = useState(false);
  const [shouldExploreData, setShouldExploreData] = useState(false);
  const [shouldOpenHelp, setShouldOpenHelp] = useState(false);
  const [shouldOpenSearch, setShouldOpenSearch] = useState(false);
  const modalRef = useRef(null);
  const welcomeMessageRef = useRef(null);
  // const {
  //   WelcomeMessagePrimaryBtnClick,
  //   WelcomeMessageSecondaryBtnClick
  // } = viewState.terria.overrides;
  const handleClose = function () {
    let persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setShowWelcomeMessage(false);
    setShouldOpenHelp(false);
    setShouldOpenSearch(false);
    if (persist) {
      viewState.terria.setLocalProperty(LOCAL_PROPERTY_KEY, true);
    }
  };
  useKeyPress("Escape", () => {
    if (showWelcomeMessage && viewState.videoGuideVisible === "") {
      handleClose(false);
    }
  });
  return /*#__PURE__*/_jsx(FadeIn, {
    isVisible: showWelcomeMessage,
    onEnter: () => setWelcomeVisible(true),
    nodeRef: modalRef,
    transitionProps: {
      onExiting: () => setWelcomeVisible(false),
      onExited: () => {
        if (shouldTakeTour) {
          setShouldTakeTour(false);
          viewState.setTourIndex(0);
          viewState.setShowTour(true);
          viewState.setTopElement(TourPortalDisplayName);
        }
        if (shouldExploreData) {
          setShouldExploreData(false);
          viewState.openAddData();
          viewState.setTopElement(ExplorerWindowElementName);
        }
        if (shouldOpenHelp) {
          setShouldOpenHelp(false);
          viewState.showHelpPanel();
        }
        if (shouldOpenSearch) {
          setShouldOpenSearch(false);
          runInAction(() => viewState.searchState.showMobileLocationSearch = true);
        }
        // Show where help is when never previously prompted
        if (!viewState.terria.getLocalProperty("helpPrompted")) {
          runInAction(() => {
            viewState.toggleFeaturePrompt("help", true, false);
          });
        }
      }
    },
    children: /*#__PURE__*/_jsx(WelcomeModalWrapper, {
      fullWidth: true,
      fullHeight: true,
      position: "absolute",
      right: true,
      onClick: () => handleClose(false),
      children: /*#__PURE__*/_jsxs(Box, {
        styledWidth: viewState.isMapFullScreen || viewState.useSmallScreenInterface ? "100%" : "calc(100% - 350px)" // TODO: use variable $work-bench-width
        ,
        fullHeight: true,
        centered: true,
        children: [/*#__PURE__*/_jsx(VideoGuide, {
          viewState: viewState,
          videoLink: viewState.terria.configParameters.welcomeMessageVideo.videoUrl,
          background: viewState.terria.configParameters.welcomeMessageVideo.placeholderImage,
          videoName: WELCOME_MESSAGE_VIDEO
        }), /*#__PURE__*/_jsx(SlideUpFadeIn, {
          isVisible: welcomeVisible,
          nodeRef: welcomeMessageRef,
          children: /*#__PURE__*/_jsxs(Box, {
            ref: welcomeMessageRef,
            styledWidth: "667px",
            styledMinHeight: "504px",
            displayInlineBlock: true,
            paddedRatio: viewState.useSmallScreenInterface ? 2 : 6,
            onClick: e => {
              viewState.setTopElement("WelcomeMessage");
              e.stopPropagation();
            },
            children: [/*#__PURE__*/_jsx(_StyledRawButton, {
              onClick: handleClose.bind(null, false),
              children: /*#__PURE__*/_jsx(StyledIcon, {
                styledWidth: "24px",
                light: true,
                glyph: Icon.GLYPHS.closeLight
              })
            }), /*#__PURE__*/_jsx(Spacing, {
              bottom: 7
            }), /*#__PURE__*/_jsxs(Box, {
              displayInlineBlock: true,
              styledWidth: viewState.useSmallScreenInterface ? "100%" : "83.33333%",
              children: [/*#__PURE__*/_jsx(Text, {
                bold: true,
                textLight: true,
                styledFontSize: viewState.useSmallScreenInterface ? "26px" : "36px",
                textAlignCenter: viewState.useSmallScreenInterface,
                styledLineHeight: "49px",
                children: t("welcomeMessage.title")
              }), /*#__PURE__*/_jsx(Spacing, {
                bottom: 3
              }), /*#__PURE__*/_jsxs(Text, {
                textLight: true,
                medium: true,
                textAlignCenter: viewState.useSmallScreenInterface,
                children: [viewState.useSmallScreenInterface === false && /*#__PURE__*/_jsxs(Trans, {
                  i18nKey: "welcomeMessage.welcomeMessage",
                  children: ["Interested in data discovery and exploration?", /*#__PURE__*/_jsx("br", {}), "Dive right in and get started or check the following help guide options."]
                }), viewState.useSmallScreenInterface === true && /*#__PURE__*/_jsx(Trans, {
                  i18nKey: "welcomeMessage.welcomeMessageOnMobile",
                  children: "Interested in data discovery and exploration?"
                })]
              })]
            }), /*#__PURE__*/_jsx(Spacing, {
              bottom: 6
            }), !viewState.useSmallScreenInterface && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Text, {
                bold: true,
                textLight: true,
                extraLarge: true,
                children: viewState.terria.configParameters.welcomeMessageVideo.videoTitle
              }), /*#__PURE__*/_jsx(Spacing, {
                bottom: 2
              })]
            }), /*#__PURE__*/_jsxs(Box, {
              fullWidth: true,
              styledMinHeight: "160px",
              children: [!viewState.useSmallScreenInterface && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(Box, {
                  col6: true,
                  centered: true,
                  backgroundImage: viewState.terria.configParameters.welcomeMessageVideo.placeholderImage,
                  backgroundBlackOverlay: 0.5,
                  children: /*#__PURE__*/_jsx(RawButton, {
                    fullWidth: true,
                    fullHeight: true,
                    onClick: () => viewState.setVideoGuideVisible(WELCOME_MESSAGE_VIDEO),
                    children: /*#__PURE__*/_jsx(_StyledStyledIcon, {
                      styledWidth: "48px",
                      light: true,
                      glyph: Icon.GLYPHS.playInverted
                    })
                  })
                }), /*#__PURE__*/_jsx(Spacing, {
                  right: 5
                })]
              }), /*#__PURE__*/_jsxs(Box, {
                styledMargin: "0 auto",
                displayInlineBlock: true,
                children: [!viewState.useSmallScreenInterface && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(WelcomeMessageButton, {
                    onClick: () => {
                      handleClose(false);
                      // not sure if we should wait for the exit animation,
                      // if we don't, we have a flicker due to the difference
                      // in overlay darkness - but if we wait, it goes
                      // dark -> light -> dark anyway..
                      setShouldTakeTour(true);
                      viewState.setTourIndex(0);
                      viewState.setShowTour(true);
                      viewState.setTopElement(TourPortalDisplayName);
                    },
                    buttonText: t("welcomeMessage.tourBtnText"),
                    buttonIcon: Icon.GLYPHS.tour
                  }), /*#__PURE__*/_jsx(Spacing, {
                    bottom: 4
                  }), /*#__PURE__*/_jsx(WelcomeMessageButton, {
                    buttonText: t("welcomeMessage.helpBtnText"),
                    buttonIcon: Icon.GLYPHS.newHelp,
                    onClick: () => {
                      handleClose(false);
                      setShouldOpenHelp(true);
                    }
                  })]
                }), /*#__PURE__*/_jsx(Spacing, {
                  bottom: 4
                }), /*#__PURE__*/_jsx(WelcomeMessageButton, {
                  buttonText: t("welcomeMessage.exploreDataBtnText"),
                  buttonIcon: Icon.GLYPHS.add,
                  onClick: () => {
                    handleClose(false);
                    setShouldExploreData(true);
                  }
                }), viewState.useSmallScreenInterface && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Spacing, {
                    bottom: 4
                  }), /*#__PURE__*/_jsx(WelcomeMessageButton, {
                    buttonText: t("welcomeMessage.searchBtnText"),
                    buttonIcon: Icon.GLYPHS.search,
                    onClick: () => {
                      handleClose(false);
                      setShouldOpenSearch(true);
                    }
                  })]
                })]
              })]
            }), !viewState.useSmallScreenInterface && /*#__PURE__*/_jsx(Spacing, {
              bottom: 13
            }), /*#__PURE__*/_jsx(Box, {
              fullWidth: true,
              centered: true,
              children: /*#__PURE__*/_jsx(RawButton, {
                onClick: handleClose.bind(null, true),
                children: /*#__PURE__*/_jsx(TextSpan, {
                  textLight: true,
                  isLink: true,
                  children: t("welcomeMessage.dismissText")
                })
              })
            })]
          })
        })]
      })
    })
  });
};
WelcomeMessagePure.propTypes = {
  showWelcomeMessage: PropTypes.bool.isRequired,
  setShowWelcomeMessage: PropTypes.func.isRequired,
  isTopElement: PropTypes.bool.isRequired,
  viewState: PropTypes.object.isRequired
};
export default withTranslation()(withViewState(withTheme(WelcomeMessage)));
var _StyledRawButton = styled(RawButton).withConfig({
  displayName: "WelcomeMessage___StyledRawButton",
  componentId: "sc-1xu3b82-1"
})(["float:right;"]);
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "WelcomeMessage___StyledStyledIcon",
  componentId: "sc-1xu3b82-2"
})(["margin:auto;"]);